import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pagination from '@/views/mixin/page';
import { mapGetters } from 'vuex';
import customContainerHeader from '@/components/custom-container-header';
import { getmenu, AddOrModifySave, MenuDelete, IsExistsLinkUrl, getLoadDataSub as _getLoadDataSub, DeleteSub, AddOrModifySubSave } from '@/api/sys.menu';
import { // eslint-disable-next-line
LoadData as _LoadData // eslint-disable-next-line
, SaveData as _SaveData } from '@/api/MesPadClientMenus';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';
export default {
  name: 'menuIndex',
  mixins: [pagination],
  components: {
    customContainerHeader: customContainerHeader
  },
  computed: _objectSpread({}, mapGetters(['username'])),
  data: function data() {
    var checkPid = function checkPid(rule, value, callback) {
      if (!value && value !== 0) {
        return callback(new Error('请选择上级菜单'));
      }

      callback();
    };

    return {
      fleshTree: true,
      defaultProps: {
        children: 'children',
        label: this.$i18n.locale === 'en' ? 'MENU_EN' : 'Menu_Name'
      },
      defaultPropsPAD: {
        children: 'children',
        label: this.$i18n.locale === 'en' ? 'MENU_EN' : 'MENU_NAME'
      },
      casProps: {
        label: this.$i18n.locale === 'en' ? 'MENU_EN' : 'Menu_Name',
        value: 'Id',
        children: 'children',
        checkStrictly: true
      },
      casPropsPAD: {
        label: this.$i18n.locale === 'en' ? 'MENU_EN' : 'MENU_NAME',
        value: 'ID',
        children: 'children',
        checkStrictly: true
      },
      dialogFormVisible: false,
      dialogFormVisiblePAD: false,
      titleTextPAD: '',
      titleText: '',
      mainTable: [],
      loading: false,
      superior: [],
      superiorPAD: [],
      treeData: [],
      filterText: '',
      filterTextPAD: '',
      form: {},
      rules: {
        Menu_Code: [{
          required: true,
          message: this.$t('Menu.askCallAlias'),
          trigger: 'blur'
        }],
        Menu_Name: [{
          required: true,
          message: this.$t('Menu.askname'),
          trigger: 'blur'
        }],
        MENU_EN: [{
          required: true,
          message: this.$t('Menu.en_name_tips'),
          trigger: 'blur'
        }],
        Parent_Id: [{
          required: true,
          message: this.$t('Menu.askupper'),
          trigger: 'blur'
        }],
        Link_Url: [{
          required: true,
          message: this.$t('Menu.asklinkaddress'),
          trigger: 'blur'
        }],
        Target: [{
          required: true,
          message: this.$t('Menu.sakwindow'),
          trigger: 'blur'
        }]
      },
      card2Height: 0,
      addOrModifyFlag: false,
      addOrMidifyStatus: '',
      // 按钮相关
      otherForm: {},
      otherFormPAD: {},
      otherRules: {
        Menu_Code: [{
          required: true,
          message: this.$t('Menu.askMenucode'),
          trigger: 'blur'
        }],
        Menu_Name: [{
          required: true,
          message: this.$t('Menu.askname'),
          trigger: 'blur'
        }],
        MENU_EN: [{
          required: true,
          message: this.$t('Menu.en_name_tips'),
          trigger: 'blur'
        }],
        Link_Url: [{
          required: true,
          message: this.$t('Menu.asklinkaddress'),
          trigger: 'blur'
        }]
      },
      otherRulesPAD: {
        MENU_CODE: [{
          required: true,
          message: this.$t('Menu.askMenucode'),
          trigger: 'blur'
        }],
        MENU_NAME: [{
          required: true,
          message: this.$t('Menu.askname'),
          trigger: 'blur'
        }],
        MENU_EN: [{
          required: true,
          message: this.$t('Menu.en_name_tips'),
          trigger: 'blur'
        }],
        LINK_URL: [{
          required: true,
          message: this.$t('Menu.asklinkaddress'),
          trigger: 'blur'
        }]
      },
      activeName: 'first',
      treeDataPAD: [],
      rulesPAD: {
        MENU_CODE: [{
          required: true,
          message: '请输入调用别名',
          trigger: 'blur'
        }],
        MENU_NAME: [{
          required: true,
          message: '请输入中文名称',
          trigger: 'blur'
        }],
        MENU_EN: [{
          required: true,
          message: '请输入英文名称',
          trigger: 'blur'
        }],
        P_ID: [{
          required: true,
          validator: checkPid,
          trigger: 'blur'
        }],
        LINK_URL: [{
          required: true,
          message: '请输入链接地址',
          trigger: 'blur'
        }]
      },
      formPAD: {},
      mainTablePAD: []
    };
  },
  methods: {
    getCardHeight: function getCardHeight() {
      var card1 = this.$refs.card1.$el.offsetHeight;
      this.card2Height = 60 + 44 + 53 + 30 + card1;
    },
    // 获取菜单列表
    getList: function getList() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, getTree, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getmenu({
                  TERMINAL: 'PC',
                  MENU_KIND: 'SCM'
                });

              case 2:
                response = _context.sent;

                // console.log('获取菜单列表res',response);
                if (response.code === 0) {
                  // eslint-disable-next-line no-inner-declarations
                  getTree = function getTree(data) {
                    return data.map(function (item) {
                      if (item.children && item.children.length > 0) {
                        item.children = getTree(item.children);
                      } else {
                        item.children = null;
                      }

                      return item;
                    });
                  };

                  _this.treeData = JSON.parse(JSON.stringify(response.data));
                  data = JSON.parse(JSON.stringify(response.data));
                  _this.superior = getTree(data);

                  _this.superior.unshift({
                    children: null,
                    Parent_Id: 0,
                    Id: 0,
                    Menu_Name: '顶级菜单',
                    MENU_EN: 'Top menu'
                  });
                } else {
                  _this.treeData = [];
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 获取PAD端菜单列表
    getListforPAD: function getListforPAD() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, data, getTree;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                getTree = function _getTree(arr) {
                  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                  var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                  var x = [];

                  for (var i = 0; i < arr.length; i++) {
                    var item = cloneDeep(arr[i]);
                    item.children = null;
                    item.level = level;

                    if (item.P_ID === id) {
                      item.children = getTree(arr, item.ID, level + 1);
                      x.push(item);
                    }
                  }

                  return x && x.length ? x : null;
                };

                _context2.next = 3;
                return _LoadData({
                  Page: 1,
                  Limit: 1000,
                  MENU_TYPE: 0,
                  IS_ENABLED: 'Y'
                });

              case 3:
                res = _context2.sent;
                // TODO 需要手动组装成tree状结构的数据
                data = res.Result || [];
                _this2.superiorPAD = getTree(data) || [];
                _this2.treeDataPAD = cloneDeep(_this2.superiorPAD);

                _this2.superiorPAD.unshift({
                  children: null,
                  P_ID: 0,
                  ID: 0,
                  MENU_NAME: '顶级菜单',
                  MENU_EN: 'Top Menu'
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 菜单管理搜索
    filterNode: function filterNode(value, data) {
      if (!value) return true;

      if (this.$i18n.locale === 'en') {
        return data.MENU_EN.indexOf(value) !== -1;
      } else {
        return data.Menu_Name.indexOf(value) !== -1;
      }
    },
    filterNodePAD: function filterNodePAD(value, data) {
      if (!value) return true;

      if (this.$i18n.locale === 'en') {
        return data.MENU_EN.indexOf(value) !== -1;
      } else {
        return data.MENU_NAME.indexOf(value) !== -1;
      }
    },
    // 菜单选中的列表
    getNodeData: function getNodeData(data) {
      console.log('菜单选中的列表', data);
      this.addOrMidifyStatus = '';
      this.addOrModifyFlag = false;
      this.form = data;
      this.getLoadDataSub();
    },
    getNodeDataPAD: function getNodeDataPAD(data) {
      this.addOrMidifyStatus = '';
      this.addOrModifyFlag = false;
      this.formPAD = data;
      this.getLoadDataSubPAD();
    },
    handleChange: function handleChange(e) {
      if (e && e.length) {
        this.form.Parent_Id = e[e.length - 1];
      }
    },
    handleChangePAD: function handleChangePAD(e) {
      this.formPAD.P_ID_ARR = e;

      if (e && e.length) {
        this.formPAD.P_ID = e[e.length - 1];
      }
    },
    // 添加
    handlerAdd: function handlerAdd() {
      this.resetForm();
      this.addOrModifyFlag = true;
      this.mainTable = [];
      this.mainTablePAD = [];
      this.addOrMidifyStatus = 'add';
    },
    resetForm: function resetForm() {
      // this.otherForm = {
      //   TERMINAL: 'PC',
      //   MENU_KIND: 'SCM',
      //   ENABLED: 'Y'
      // }
      this.form = {
        TERMINAL: 'PC',
        Is_System: 'Y',
        Spread: 'Y',
        ENABLED: 'Y',
        MENU_KIND: 'SCM'
      }; // this.otherFormPAD = {
      //   ENABLED: 'Y'
      // }
      // this.formPAD = {
      //   ENABLED: 'Y'
      // }
    },
    handlerEdit: function handlerEdit() {
      if (this.form.Id) {
        this.addOrModifyFlag = true;
        this.addOrMidifyStatus = 'edit';
      } else {
        this.$message({
          showClose: true,
          type: 'warning',
          message: this.$t('Menu.sakmenu')
        });
      }
    },
    handlerEditPAD: function handlerEditPAD() {
      if (this.formPAD.ID) {
        this.addOrModifyFlag = true;
        this.addOrMidifyStatus = 'edit';
      } else {
        this.$message({
          showClose: true,
          type: 'warning',
          message: this.$t('Menu.sakmenu')
        });
      }
    },
    handleCancel: function handleCancel() {
      if (this.addOrMidifyStatus === 'edit') {
        this.addOrModifyFlag = false;
      } else {
        this.resetForm();
        this.addOrModifyFlag = false;
      }

      this.addOrMidifyStatus = '';
    },
    // 获取按钮列表
    getLoadDataSub: function getLoadDataSub() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loading = true;
                _context3.next = 3;
                return _getLoadDataSub({
                  parentid: _this3.form.Id || 0
                });

              case 3:
                response = _context3.sent;
                console.log('按钮列表', response);
                _this3.loading = false;

                if (response.data) {
                  _this3.mainTable = response.data;
                } else {
                  _this3.mainTable = [];
                }

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 获取平板端菜单按钮
    getLoadDataSubPAD: function getLoadDataSubPAD() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.loading = true;
                _context4.next = 3;
                return _LoadData({
                  MENU_TYPE: 1,
                  Page: 1,
                  Limit: 10000,
                  P_ID: _this4.formPAD.ID || 0
                }).catch(function (_) {
                  _this4.loading = false;
                });

              case 3:
                res = _context4.sent;
                _this4.loading = false;

                if (res.Result) {
                  _this4.mainTablePAD = res.Result || [];
                } else {
                  _this4.mainTablePAD = [];
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    handleDeleteTreeNode: function handleDeleteTreeNode() {
      var _this5 = this;

      if (!this.form.Id) {
        this.$message({
          type: 'warning',
          message: this.$t('Menu.sakDeletedMenu')
        });
        return;
      }

      this.$confirm(this.$t('Menu.DeletedMenu'), this.$t('Menu.prompt'), {
        confirmButtonText: this.$t('Menu.confirm'),
        cancelButtonText: this.$t('Menu.cancel'),
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return MenuDelete(_this5.form.Id);

              case 2:
                response = _context5.sent;

                if (response.code === 0) {
                  _this5.getList();

                  _this5.mainTable = [];
                  _this5.loading = false;

                  _this5.resetForm();

                  _this5.$notify({
                    title: _this5.$t('Menu.success'),
                    message: _this5.$t('Menu.sudeleted'),
                    type: 'success',
                    duration: 2000
                  });
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      })));
    },
    // PAD菜单删除
    handleDeleteTreeNodePAD: function handleDeleteTreeNodePAD() {
      var _this6 = this;

      if (!this.formPAD.ID) {
        this.$message({
          type: 'warning',
          message: this.$t('Menu.sakDeletedMenu')
        });
        return false;
      }

      this.$confirm(this.$t('Menu.DeletedMenu'), this.$t('Menu.prompt'), {
        confirmButtonText: this.$t('Menu.confirm'),
        cancelButtonText: this.$t('Menu.cancel'),
        type: 'warning'
      }).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_) {
          var res;
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return _SaveData({
                    RemoveRecords: [{
                      P_ID: _this6.formPAD.P_ID,
                      P_ID_ARR: _this6.formPAD.P_ID_ARR ? JSON.stringify(_this6.formPAD.P_ID_ARR) : '',
                      PAGE_URL: _this6.formPAD.PAGE_URL || '',
                      LINK_URL: _this6.formPAD.LINK_URL || '',
                      ICON_URL: _this6.formPAD.ICON_URL || '',
                      MENU_CODE: _this6.formPAD.MENU_CODE || '',
                      MENU_NAME: _this6.formPAD.MENU_NAME || '',
                      MENU_EN: _this6.formPAD.MENU_EN || '',
                      ENABLED: _this6.formPAD.ENABLED || 'Y',
                      SORT: _this6.formPAD.SORT || 0,
                      ID: _this6.formPAD.ID || 0,
                      MENU_TYPE: 0,
                      CREATE_USER: _this6.username,
                      CREATE_TIME: dayjs().format('YYYY-MM-DD'),
                      UPDATE_USER: _this6.username,
                      UPDATE_TIME: dayjs().format('YYYY-MM-DD')
                    }]
                  });

                case 2:
                  res = _context6.sent;

                  if (res.Result) {
                    //   this.getListforPAD()
                    _this6.mainTablePAD = [];
                    _this6.loading = false;

                    _this6.resetForm();

                    _this6.$notify({
                      title: _this6.$t('Menu.success'),
                      message: _this6.$t('Menu.sudeleted'),
                      type: 'success',
                      duration: 2000
                    });
                  }

                case 4:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    // 保存
    handleSave: function handleSave() {
      var _this7 = this;

      this.$refs.form.validate( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(valid) {
          var params, _params, response, res;

          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  if (!valid) {
                    _context7.next = 27;
                    break;
                  }

                  _this7.form.children = [];
                  console.log('this.form', _this7.form);
                  params = {
                    TERMINAL: 'PC',
                    Is_System: 'Y',
                    Spread: 'Y',
                    ENABLED: 'Y',
                    MENU_KIND: 'SCM'
                  };
                  _params = Object.assign(params, _this7.form); // console.log('_params',_params);

                  _context7.next = 7;
                  return IsExistsLinkUrl(_params);

                case 7:
                  response = _context7.sent;

                  if (!(response.code === 0)) {
                    _context7.next = 24;
                    break;
                  }

                  if (!(response.Result && _this7.form.Id === 0)) {
                    _context7.next = 14;
                    break;
                  }

                  _this7.$message({
                    type: 'error',
                    message: _this7.$t('Menu.tips_one')
                  });

                  return _context7.abrupt("return", false);

                case 14:
                  if (!(_this7.form.Id && _this7.form.Id === _this7.form.Parent_Id)) {
                    _context7.next = 17;
                    break;
                  }

                  _this7.$message.error(_this7.$t('Menu._3'));

                  return _context7.abrupt("return", false);

                case 17:
                  _context7.next = 19;
                  return AddOrModifySave(_this7.form);

                case 19:
                  res = _context7.sent;
                  console.log('保存菜单 res', res);

                  if (res.code === 0) {
                    _this7.addOrModifyFlag = false;
                    _this7.addOrMidifyStatus = '';

                    _this7.getList();

                    _this7.resetForm();

                    _this7.$notify({
                      title: _this7.$t('Menu.success'),
                      message: _this7.$t('Menu.updatesucc'),
                      type: 'success',
                      duration: 2000
                    });
                  } else {
                    _this7.$message.warning(res.message);
                  }

                case 22:
                  _context7.next = 25;
                  break;

                case 24:
                  _this7.$message.warning(response.message);

                case 25:
                  _context7.next = 28;
                  break;

                case 27:
                  return _context7.abrupt("return", false);

                case 28:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));

        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    // PAD端菜单保存
    handleSavePAD: function handleSavePAD() {
      var _this8 = this;

      this.$refs.formPAD.validate( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(valid) {
          var form, res;
          return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  if (!valid) {
                    _context8.next = 10;
                    break;
                  }

                  if (!(_this8.formPAD.ID === _this8.formPAD.P_ID)) {
                    _context8.next = 4;
                    break;
                  }

                  _this8.$message.error(_this8.$t('Menu._3'));

                  return _context8.abrupt("return", false);

                case 4:
                  form = {};

                  if (_this8.formPAD.ID) {
                    // 保存
                    form.UpdateRecords = [{
                      P_ID: _this8.formPAD.P_ID,
                      P_ID_ARR: JSON.stringify(_this8.formPAD.P_ID_ARR),
                      PAGE_URL: _this8.formPAD.PAGE_URL || '',
                      LINK_URL: _this8.formPAD.LINK_URL || '',
                      ICON_URL: _this8.formPAD.ICON_URL || '',
                      MENU_CODE: _this8.formPAD.MENU_CODE || '',
                      MENU_NAME: _this8.formPAD.MENU_NAME || '',
                      MENU_EN: _this8.formPAD.MENU_EN || '',
                      ENABLED: _this8.formPAD.ENABLED || 'Y',
                      SORT: _this8.formPAD.SORT || 0,
                      ID: _this8.formPAD.ID || 0,
                      MENU_TYPE: 0,
                      CREATE_USER: _this8.username,
                      CREATE_TIME: dayjs().format('YYYY-MM-DD'),
                      UPDATE_USER: _this8.username,
                      UPDATE_TIME: dayjs().format('YYYY-MM-DD')
                    }];
                  } else {
                    // 新增
                    form.InsertRecords = [{
                      P_ID: _this8.formPAD.P_ID,
                      P_ID_ARR: JSON.stringify(_this8.formPAD.P_ID_ARR),
                      PAGE_URL: _this8.formPAD.PAGE_URL || '',
                      LINK_URL: _this8.formPAD.LINK_URL || '',
                      ICON_URL: _this8.formPAD.ICON_URL || '',
                      MENU_CODE: _this8.formPAD.MENU_CODE || '',
                      MENU_NAME: _this8.formPAD.MENU_NAME || '',
                      MENU_EN: _this8.formPAD.MENU_EN || '',
                      ENABLED: _this8.formPAD.ENABLED || 'Y',
                      SORT: _this8.formPAD.SORT || 0,
                      ID: _this8.formPAD.ID || 0,
                      MENU_TYPE: 0,
                      CREATE_USER: _this8.username,
                      CREATE_TIME: dayjs().format('YYYY-MM-DD'),
                      UPDATE_USER: _this8.username,
                      UPDATE_TIME: dayjs().format('YYYY-MM-DD')
                    }];
                  }

                  _context8.next = 8;
                  return _SaveData(form);

                case 8:
                  res = _context8.sent;

                  if (res.Result) {
                    _this8.addOrModifyFlag = false;
                    _this8.addOrMidifyStatus = ''; // this.getListforPAD()

                    _this8.resetForm();

                    _this8.$notify({
                      title: '提示',
                      message: form.ID ? '修改' : '新增' + '菜单成功',
                      type: 'success'
                    });
                  }

                case 10:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        return function (_x3) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    // 按钮修改
    handleUpdate: function handleUpdate(row) {
      this.otherForm = row;
      this.dialogFormVisible = true;
      this.titleText = this.$t('Menu._1');
    },
    // 平板端按钮修改
    handleUpdatePAD: function handleUpdatePAD(row) {
      this.otherFormPAD = row;
      this.dialogFormVisiblePAD = true;
      this.titleTextPAD = this.$t('Menu._1');
    },
    // 按钮删除
    handleDelete: function handleDelete(row) {
      var _this9 = this;

      this.$confirm(this.$t('Menu.detDeletebutton'), this.$t('Menu.prompt'), {
        confirmButtonText: this.$t('Menu.confirm'),
        cancelButtonText: this.$t('Menu.cancel'),
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var response, index;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return DeleteSub(row.Id);

              case 2:
                response = _context9.sent;

                if (response.code === 0) {
                  _this9.$notify({
                    title: _this9.$t('Menu.success'),
                    message: _this9.$t('Menu.sudeleted'),
                    type: 'success',
                    duration: 2000
                  });

                  index = _this9.mainTable.indexOf(row);

                  _this9.mainTable.splice(index, 1);
                }

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      })));
    },
    handleDeletePAD: function handleDeletePAD(row) {
      var _this10 = this;

      this.$confirm(this.$t('Menu.detDeletebutton'), this.$t('Menu.prompt'), {
        confirmButtonText: this.$t('Menu.confirm'),
        cancelButtonText: this.$t('Menu.cancel'),
        type: 'warning'
      }).then( /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(_) {
          var res, index;
          return regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.next = 2;
                  return _SaveData({
                    RemoveRecords: [row]
                  });

                case 2:
                  res = _context10.sent;

                  if (res.Result) {
                    _this10.$notify({
                      title: _this10.$t('Menu.success'),
                      message: _this10.$t('Menu.sudeleted'),
                      type: 'success',
                      duration: 2000
                    });

                    index = _this10.mainTablePAD.indexOf(row);

                    _this10.mainTablePAD.splice(index, 1);
                  }

                case 4:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10);
        }));

        return function (_x4) {
          return _ref6.apply(this, arguments);
        };
      }());
    },
    // 新增按钮
    handleAddBtn: function handleAddBtn() {
      this.dialogFormVisible = true;
      this.otherForm = {
        Parent_Id: this.form.Id || 0,
        Is_System: 'N',
        ENABLED: 'Y'
      };
      this.titleText = this.$t('Menu._2');
    },
    handleAddBtnPAD: function handleAddBtnPAD() {
      this.dialogFormVisiblePAD = true;
      this.otherFormPAD = {
        P_ID: this.formPAD.ID || 0,
        ENABLED: 'Y'
      };
      this.titleTextPAD = this.$t('Menu._2');
    },
    cancel: function cancel() {
      this.otherForm = {};
      this.dialogFormVisible = false;
    },
    cancelPAD: function cancelPAD() {
      this.otherFormPAD = {};
      this.dialogFormVisiblePAD = false;
    },
    // 新增或修改编辑按钮保存
    create: function create() {
      var _this11 = this;

      this.$refs.otherForm.validate( /*#__PURE__*/function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(valid) {
          var params, _params, response;

          return regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  if (!valid) {
                    _context11.next = 7;
                    break;
                  }

                  // if (!this.otherForm.Id) {
                  //   this.otherForm.Id = 0
                  //   this.otherForm.MENU_TYPE = 2
                  //   this.otherForm.Modify_Manager_Id = null
                  //   this.otherForm.Modify_Time = null
                  //   this.otherForm.Spread = 'N'
                  //   this.otherForm.Icon_Url = null
                  // }
                  params = {
                    Is_System: 'N',
                    ENABLED: 'Y',
                    Parent_Id: _this11.form.Id || 0,
                    MENU_KIND: 'SCM',
                    TERMINAL: 'PC'
                  };
                  _params = Object.assign(params, _this11.otherForm); // console.log('_params',_params);

                  _context11.next = 5;
                  return AddOrModifySubSave(_params);

                case 5:
                  response = _context11.sent;

                  if (response.code === 0) {
                    _this11.dialogFormVisible = false;

                    _this11.getLoadDataSub();

                    _this11.$notify({
                      title: _this11.$t('Menu.success'),
                      message: _this11.$t('Menu.addsuccess'),
                      type: 'success',
                      duration: 2000
                    });
                  } else {
                    _this11.$message.warning();
                  }

                case 7:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11);
        }));

        return function (_x5) {
          return _ref7.apply(this, arguments);
        };
      }());
    },
    createPAD: function createPAD() {
      var _this12 = this;

      this.$refs.otherFormPAD.validate( /*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(valid) {
          var items, form, res;
          return regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  if (!valid) {
                    _context12.next = 8;
                    break;
                  }

                  items = {
                    P_ID: _this12.otherFormPAD.P_ID,
                    P_ID_ARR: '',
                    PAGE_URL: _this12.otherFormPAD.PAGE_URL || '',
                    LINK_URL: _this12.otherFormPAD.LINK_URL || '',
                    ICON_URL: _this12.otherFormPAD.ICON_URL || '',
                    MENU_CODE: _this12.otherFormPAD.MENU_CODE || '',
                    MENU_NAME: _this12.otherFormPAD.MENU_NAME || '',
                    MENU_EN: _this12.otherFormPAD.MENU_EN || '',
                    ENABLED: _this12.otherFormPAD.ENABLED || 'Y',
                    SORT: _this12.otherFormPAD.SORT || 0,
                    ID: _this12.otherFormPAD.ID || 0,
                    MENU_TYPE: 1,
                    CREATE_USER: _this12.username,
                    CREATE_TIME: dayjs().format('YYYY-MM-DD'),
                    UPDATE_USER: _this12.username,
                    UPDATE_TIME: dayjs().format('YYYY-MM-DD')
                  };
                  form = {};

                  if (items.ID) {
                    // 修改
                    form.UpdateRecords = [items];
                  } else {
                    // 新增
                    form.InsertRecords = [items];
                  }

                  _context12.next = 6;
                  return _SaveData(form);

                case 6:
                  res = _context12.sent;

                  if (res.Result) {
                    _this12.dialogFormVisiblePAD = false;

                    _this12.getLoadDataSubPAD();

                    _this12.$notify({
                      title: _this12.$t('Menu.success'),
                      message: _this12.$t('Menu.addsuccess'),
                      type: 'success',
                      duration: 2000
                    });
                  }

                case 8:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12);
        }));

        return function (_x6) {
          return _ref8.apply(this, arguments);
        };
      }());
    }
  },
  created: function created() {
    this.getList(); // this.getListforPAD()

    this.$nextTick(function () {//   this.getCardHeight()
    }); // window.addEventListener('load', this.getCardHeight)
    // window.addEventListener('resize', this.getCardHeight)
  },
  beforeDestroy: function beforeDestroy() {
    // 取消监听
    window.removeEventListener('resize', this.getCardHeight);
    window.removeEventListener('load', this.getCardHeight);
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.menuTree.filter(val);
    },
    filterTextPAD: function filterTextPAD(val) {
      this.$refs.menuTreePAD.filter(val);
    },
    activeName: function activeName(val, oldVal) {
      if (val !== oldVal) {
        this.addOrModifyFlag = false;
      }
    },
    '$i18n.locale': function $i18nLocale(val, oldVal) {
      var _this13 = this;

      this.fleshTree = false;
      this.$nextTick(function () {
        // 重新渲染 tree （代价挺大的）
        _this13.fleshTree = true;
      });
      this.defaultProps = {
        children: 'children',
        label: val === 'en' ? 'MENU_EN' : 'Menu_Name'
      };
      this.casProps = {
        label: val === 'en' ? 'MENU_EN' : 'Menu_Name',
        value: 'Id',
        children: 'children',
        checkStrictly: true
      };
    }
  }
};